function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9734 6.07848C19.3786 7.08442 20.6026 7.94055 20.6026 10.3591C20.6026 10.7444 20.9199 11.044 21.3279 11.044C21.7358 11.044 22.0532 10.7444 22.0532 10.3591C22.0532 7.25565 20.3306 6.03567 18.8347 4.96552C17.4294 3.95957 16.2055 3.10345 16.2055 0.684899C16.2281 0.299643 15.8882 0 15.4802 0C15.0722 0 14.7549 0.299643 14.7549 0.684899C14.7549 3.80975 16.4548 5.00832 17.9734 6.07848Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.549 10.3805C23.549 10.7658 23.8664 11.0654 24.2743 11.0654C24.6823 11.0654 24.9996 10.7658 24.9996 10.3805C24.9996 7.40547 24.161 6.2069 23.4131 5.15814C22.7331 4.1736 22.0758 3.25327 22.0758 0.706302C22.0758 0.299643 21.7585 0 21.3505 0C20.9425 0 20.6025 0.299643 20.6025 0.684899C20.6025 3.65993 21.4412 4.8585 22.1891 5.90725C22.8918 6.8918 23.549 7.81213 23.549 10.3805Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2747 12.4565H0.725295C0.317316 12.4565 0 12.7562 0 13.1414V17.2936C0 17.6789 0.317316 17.9785 0.725295 17.9785H24.2747C24.6827 17.9785 25 17.6789 25 17.2936V13.1414C25 12.7562 24.6827 12.4565 24.2747 12.4565ZM8.83953 16.6087H1.47325V13.8477H8.83953V16.6087ZM20.6029 16.6087H10.3128V13.8477H20.6256V16.6087H20.6029ZM23.5494 16.6087H22.0762V13.8477H23.5494V16.6087Z"
});

function SvgSmokeArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeArea);
export default __webpack_public_path__ + "static/media/smokeArea.96d04728.svg";
export { ForwardRef as ReactComponent };